import { render, staticRenderFns } from "./EndOfDay.vue?vue&type=template&id=36f5db68&scoped=true&"
import script from "./EndOfDay.vue?vue&type=script&lang=js&"
export * from "./EndOfDay.vue?vue&type=script&lang=js&"
import style0 from "./EndOfDay.vue?vue&type=style&index=0&id=36f5db68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5db68",
  null
  
)

export default component.exports